import React, { createContext, useState, useCallback } from 'react'
import PropTypes from 'prop-types'

export const LoadingContext = createContext()

export const LoadingProvider = ({ children }) => {
  const [loadingList, setLoadingList] = useState([])

  const startLoading = useCallback((uniqueId) => {
    setLoadingList((prevList) => {
      if (!prevList.includes(uniqueId)) {
        return [...prevList, uniqueId]
      }
      return prevList
    })
  }, [])

  const stopLoading = useCallback((uniqueId) => {
    setLoadingList((prevList) => prevList.filter((id) => id !== uniqueId))
  }, [])

  const isLoading = useCallback(() => {
    return loadingList.length > 0
  }, [loadingList])

  const value = {
    startLoading,
    stopLoading,
    isLoading,
    loadingList
  }

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
}

LoadingProvider.propTypes = {
  children: PropTypes.node
}
